/**
 * Generated by orval
 * Do not edit manually.
 * IP Fabric API
 * IP Fabric API documentation. For details see [IP Fabric API documentation](https://docs.ipfabric.io/main/IP_Fabric_API/)
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  PostTablesReportsDiscoveryErrors200,
  PostTablesReportsDiscoveryErrorsBody,
  PostTablesReportsDiscoveryTasks200,
  PostTablesReportsDiscoveryTasksBody,
  PostTablesReportsSettingsOui200,
  PostTablesReportsSettingsOuiBody,
} from '../../schemas';

import { apiClient } from '../../../apiClient';

/**
 * @summary Return available intent rules
 */
export const getReports = (signal?: AbortSignal) => {
  return apiClient<unknown>({ url: `/reports`, method: 'GET', signal });
};

export const getGetReportsQueryKey = () => {
  return [`/reports`] as const;
};

export const getGetReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof getReports>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReports>>> = ({
    signal,
  }) => getReports(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReports>>
>;
export type GetReportsQueryError = unknown;

export function useGetReports<
  TData = Awaited<ReturnType<typeof getReports>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReports>>,
          TError,
          Awaited<ReturnType<typeof getReports>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReports<
  TData = Awaited<ReturnType<typeof getReports>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReports>>,
          TError,
          Awaited<ReturnType<typeof getReports>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReports<
  TData = Awaited<ReturnType<typeof getReports>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Return available intent rules
 */

export function useGetReports<
  TData = Awaited<ReturnType<typeof getReports>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReports>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetReportsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates an intent rules for specific table with specified properties
 * @summary Create intent rule
 */
export const postReports = (signal?: AbortSignal) => {
  return apiClient<unknown>({ url: `/reports`, method: 'POST', signal });
};

export const getPostReportsMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postReports>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postReports>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['postReports'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postReports>>,
    void
  > = () => {
    return postReports();
  };

  return { mutationFn, ...mutationOptions };
};

export type PostReportsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postReports>>
>;

export type PostReportsMutationError = unknown;

/**
 * @summary Create intent rule
 */
export const usePostReports = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postReports>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postReports>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = getPostReportsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Deletes a specific intent rule that is defined by its ID
 * @summary Delete intent rule
 */
export const deleteReportsKey = (key: string) => {
  return apiClient<unknown>({ url: `/reports/${key}`, method: 'DELETE' });
};

export const getDeleteReportsKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReportsKey>>,
    TError,
    { key: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteReportsKey>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationKey = ['deleteReportsKey'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteReportsKey>>,
    { key: string }
  > = (props) => {
    const { key } = props ?? {};

    return deleteReportsKey(key);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteReportsKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteReportsKey>>
>;

export type DeleteReportsKeyMutationError = unknown;

/**
 * @summary Delete intent rule
 */
export const useDeleteReportsKey = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteReportsKey>>,
      TError,
      { key: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteReportsKey>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationOptions = getDeleteReportsKeyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns the specific intent rules that are defined by their ID
 * @summary Return specific intent rule information
 */
export const getReportsKey = (key: string, signal?: AbortSignal) => {
  return apiClient<unknown>({ url: `/reports/${key}`, method: 'GET', signal });
};

export const getGetReportsKeyQueryKey = (key: string) => {
  return [`/reports/${key}`] as const;
};

export const getGetReportsKeyQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportsKey>>,
  TError = unknown,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsKey>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReportsKeyQueryKey(key);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsKey>>> = ({
    signal,
  }) => getReportsKey(key, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!key,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportsKey>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportsKeyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportsKey>>
>;
export type GetReportsKeyQueryError = unknown;

export function useGetReportsKey<
  TData = Awaited<ReturnType<typeof getReportsKey>>,
  TError = unknown,
>(
  key: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsKey>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsKey>>,
          TError,
          Awaited<ReturnType<typeof getReportsKey>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReportsKey<
  TData = Awaited<ReturnType<typeof getReportsKey>>,
  TError = unknown,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsKey>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsKey>>,
          TError,
          Awaited<ReturnType<typeof getReportsKey>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReportsKey<
  TData = Awaited<ReturnType<typeof getReportsKey>>,
  TError = unknown,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsKey>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Return specific intent rule information
 */

export function useGetReportsKey<
  TData = Awaited<ReturnType<typeof getReportsKey>>,
  TError = unknown,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getReportsKey>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetReportsKeyQueryOptions(key, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates a specific intent rule that is defined by its ID
 * @summary Update intent rule
 */
export const patchReportsKey = (key: string) => {
  return apiClient<unknown>({ url: `/reports/${key}`, method: 'PATCH' });
};

export const getPatchReportsKeyMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchReportsKey>>,
    TError,
    { key: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchReportsKey>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationKey = ['patchReportsKey'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchReportsKey>>,
    { key: string }
  > = (props) => {
    const { key } = props ?? {};

    return patchReportsKey(key);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchReportsKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchReportsKey>>
>;

export type PatchReportsKeyMutationError = unknown;

/**
 * @summary Update intent rule
 */
export const usePatchReportsKey = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchReportsKey>>,
      TError,
      { key: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof patchReportsKey>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationOptions = getPatchReportsKeyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary POST /tables/reports/discovery-errors
 */
export const postTablesReportsDiscoveryErrors = (
  postTablesReportsDiscoveryErrorsBody: PostTablesReportsDiscoveryErrorsBody,
  signal?: AbortSignal,
) => {
  return apiClient<PostTablesReportsDiscoveryErrors200>({
    url: `/tables/reports/discovery-errors`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTablesReportsDiscoveryErrorsBody,
    signal,
  });
};

export const getPostTablesReportsDiscoveryErrorsQueryKey = (
  postTablesReportsDiscoveryErrorsBody: PostTablesReportsDiscoveryErrorsBody,
) => {
  return [
    `/tables/reports/discovery-errors`,
    postTablesReportsDiscoveryErrorsBody,
  ] as const;
};

export const getPostTablesReportsDiscoveryErrorsQueryOptions = <
  TData = Awaited<ReturnType<typeof postTablesReportsDiscoveryErrors>>,
  TError = unknown,
>(
  postTablesReportsDiscoveryErrorsBody: PostTablesReportsDiscoveryErrorsBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesReportsDiscoveryErrors>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPostTablesReportsDiscoveryErrorsQueryKey(
      postTablesReportsDiscoveryErrorsBody,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof postTablesReportsDiscoveryErrors>>
  > = ({ signal }) =>
    postTablesReportsDiscoveryErrors(
      postTablesReportsDiscoveryErrorsBody,
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postTablesReportsDiscoveryErrors>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostTablesReportsDiscoveryErrorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof postTablesReportsDiscoveryErrors>>
>;
export type PostTablesReportsDiscoveryErrorsQueryError = unknown;

export function usePostTablesReportsDiscoveryErrors<
  TData = Awaited<ReturnType<typeof postTablesReportsDiscoveryErrors>>,
  TError = unknown,
>(
  postTablesReportsDiscoveryErrorsBody: PostTablesReportsDiscoveryErrorsBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesReportsDiscoveryErrors>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesReportsDiscoveryErrors>>,
          TError,
          Awaited<ReturnType<typeof postTablesReportsDiscoveryErrors>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesReportsDiscoveryErrors<
  TData = Awaited<ReturnType<typeof postTablesReportsDiscoveryErrors>>,
  TError = unknown,
>(
  postTablesReportsDiscoveryErrorsBody: PostTablesReportsDiscoveryErrorsBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesReportsDiscoveryErrors>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesReportsDiscoveryErrors>>,
          TError,
          Awaited<ReturnType<typeof postTablesReportsDiscoveryErrors>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesReportsDiscoveryErrors<
  TData = Awaited<ReturnType<typeof postTablesReportsDiscoveryErrors>>,
  TError = unknown,
>(
  postTablesReportsDiscoveryErrorsBody: PostTablesReportsDiscoveryErrorsBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesReportsDiscoveryErrors>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary POST /tables/reports/discovery-errors
 */

export function usePostTablesReportsDiscoveryErrors<
  TData = Awaited<ReturnType<typeof postTablesReportsDiscoveryErrors>>,
  TError = unknown,
>(
  postTablesReportsDiscoveryErrorsBody: PostTablesReportsDiscoveryErrorsBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesReportsDiscoveryErrors>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostTablesReportsDiscoveryErrorsQueryOptions(
    postTablesReportsDiscoveryErrorsBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary POST /tables/reports/discovery-tasks
 */
export const postTablesReportsDiscoveryTasks = (
  postTablesReportsDiscoveryTasksBody: PostTablesReportsDiscoveryTasksBody,
  signal?: AbortSignal,
) => {
  return apiClient<PostTablesReportsDiscoveryTasks200>({
    url: `/tables/reports/discovery-tasks`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTablesReportsDiscoveryTasksBody,
    signal,
  });
};

export const getPostTablesReportsDiscoveryTasksQueryKey = (
  postTablesReportsDiscoveryTasksBody: PostTablesReportsDiscoveryTasksBody,
) => {
  return [
    `/tables/reports/discovery-tasks`,
    postTablesReportsDiscoveryTasksBody,
  ] as const;
};

export const getPostTablesReportsDiscoveryTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof postTablesReportsDiscoveryTasks>>,
  TError = unknown,
>(
  postTablesReportsDiscoveryTasksBody: PostTablesReportsDiscoveryTasksBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesReportsDiscoveryTasks>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPostTablesReportsDiscoveryTasksQueryKey(
      postTablesReportsDiscoveryTasksBody,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof postTablesReportsDiscoveryTasks>>
  > = ({ signal }) =>
    postTablesReportsDiscoveryTasks(
      postTablesReportsDiscoveryTasksBody,
      signal,
    );

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postTablesReportsDiscoveryTasks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostTablesReportsDiscoveryTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof postTablesReportsDiscoveryTasks>>
>;
export type PostTablesReportsDiscoveryTasksQueryError = unknown;

export function usePostTablesReportsDiscoveryTasks<
  TData = Awaited<ReturnType<typeof postTablesReportsDiscoveryTasks>>,
  TError = unknown,
>(
  postTablesReportsDiscoveryTasksBody: PostTablesReportsDiscoveryTasksBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesReportsDiscoveryTasks>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesReportsDiscoveryTasks>>,
          TError,
          Awaited<ReturnType<typeof postTablesReportsDiscoveryTasks>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesReportsDiscoveryTasks<
  TData = Awaited<ReturnType<typeof postTablesReportsDiscoveryTasks>>,
  TError = unknown,
>(
  postTablesReportsDiscoveryTasksBody: PostTablesReportsDiscoveryTasksBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesReportsDiscoveryTasks>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesReportsDiscoveryTasks>>,
          TError,
          Awaited<ReturnType<typeof postTablesReportsDiscoveryTasks>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesReportsDiscoveryTasks<
  TData = Awaited<ReturnType<typeof postTablesReportsDiscoveryTasks>>,
  TError = unknown,
>(
  postTablesReportsDiscoveryTasksBody: PostTablesReportsDiscoveryTasksBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesReportsDiscoveryTasks>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary POST /tables/reports/discovery-tasks
 */

export function usePostTablesReportsDiscoveryTasks<
  TData = Awaited<ReturnType<typeof postTablesReportsDiscoveryTasks>>,
  TError = unknown,
>(
  postTablesReportsDiscoveryTasksBody: PostTablesReportsDiscoveryTasksBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesReportsDiscoveryTasks>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostTablesReportsDiscoveryTasksQueryOptions(
    postTablesReportsDiscoveryTasksBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Internal database for Organizational Unique Identifier (OUI) to either allow ARP discovery or not
 * @summary Settings for OUI Discovery
 */
export const postTablesReportsSettingsOui = (
  postTablesReportsSettingsOuiBody: PostTablesReportsSettingsOuiBody,
  signal?: AbortSignal,
) => {
  return apiClient<PostTablesReportsSettingsOui200>({
    url: `/tables/reports/settings-oui`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postTablesReportsSettingsOuiBody,
    signal,
  });
};

export const getPostTablesReportsSettingsOuiQueryKey = (
  postTablesReportsSettingsOuiBody: PostTablesReportsSettingsOuiBody,
) => {
  return [
    `/tables/reports/settings-oui`,
    postTablesReportsSettingsOuiBody,
  ] as const;
};

export const getPostTablesReportsSettingsOuiQueryOptions = <
  TData = Awaited<ReturnType<typeof postTablesReportsSettingsOui>>,
  TError = unknown,
>(
  postTablesReportsSettingsOuiBody: PostTablesReportsSettingsOuiBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesReportsSettingsOui>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getPostTablesReportsSettingsOuiQueryKey(postTablesReportsSettingsOuiBody);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof postTablesReportsSettingsOui>>
  > = ({ signal }) =>
    postTablesReportsSettingsOui(postTablesReportsSettingsOuiBody, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postTablesReportsSettingsOui>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostTablesReportsSettingsOuiQueryResult = NonNullable<
  Awaited<ReturnType<typeof postTablesReportsSettingsOui>>
>;
export type PostTablesReportsSettingsOuiQueryError = unknown;

export function usePostTablesReportsSettingsOui<
  TData = Awaited<ReturnType<typeof postTablesReportsSettingsOui>>,
  TError = unknown,
>(
  postTablesReportsSettingsOuiBody: PostTablesReportsSettingsOuiBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesReportsSettingsOui>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesReportsSettingsOui>>,
          TError,
          Awaited<ReturnType<typeof postTablesReportsSettingsOui>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesReportsSettingsOui<
  TData = Awaited<ReturnType<typeof postTablesReportsSettingsOui>>,
  TError = unknown,
>(
  postTablesReportsSettingsOuiBody: PostTablesReportsSettingsOuiBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesReportsSettingsOui>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postTablesReportsSettingsOui>>,
          TError,
          Awaited<ReturnType<typeof postTablesReportsSettingsOui>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostTablesReportsSettingsOui<
  TData = Awaited<ReturnType<typeof postTablesReportsSettingsOui>>,
  TError = unknown,
>(
  postTablesReportsSettingsOuiBody: PostTablesReportsSettingsOuiBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesReportsSettingsOui>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Settings for OUI Discovery
 */

export function usePostTablesReportsSettingsOui<
  TData = Awaited<ReturnType<typeof postTablesReportsSettingsOui>>,
  TError = unknown,
>(
  postTablesReportsSettingsOuiBody: PostTablesReportsSettingsOuiBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postTablesReportsSettingsOui>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostTablesReportsSettingsOuiQueryOptions(
    postTablesReportsSettingsOuiBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
